import React from 'react'
import Results from '../QuizResults/Results'
import { useQuiz } from '../QuizProvider'
import useTranslation from '../../shared/TranslationProvider'
import { useIsDesktop } from '../../../hooks/useMediaQuery'
import Avatar from '../Avatar'
import { usePointsQuizScore } from '~/components/JobSearchQuiz/useScoreCalculator'
import TaskCompletedModal from '~/components/shared/TaskCompletedModal'

const RetirementReadinessResults = () => {
  const { t } = useTranslation('retirement_readiness')
  const { trackContent, resultsPageAvatar, inActionPlan, locale } = useQuiz()

  const breakPoints = [27, 17]

  const [scoreSection, score] = usePointsQuizScore(
    trackContent,
    t('questions'),
    breakPoints,
    'raw',
  )

  const copy = t(`results.${scoreSection}.copy`)
  const subtitle = t(`results.${scoreSection}.subtitle`)
  const nextSteps = t(`results.${scoreSection}.next_steps`)

  const isDesktop = useIsDesktop()

  return (
    <>
      <Results>
        <div className="mb-8 flex pb-6 sm:justify-around">
          <div className="mt-1 flex h-96 flex-col gap-4 sm:w-9/12">
            <h2>{t(`results.score`, { score })}</h2>
            <div className="subtitle mt-4">{subtitle}</div>
            <div>
              {copy.map((par, idx) => (
                <p key={`results-page-${idx}`}>{par}</p>
              ))}
            </div>
            <div className="subtitle mt-4">{t('results.next_steps')}:</div>
            <div>{nextSteps}</div>
          </div>
          {isDesktop && <Avatar src={resultsPageAvatar} />}
        </div>
      </Results>
      {inActionPlan && <TaskCompletedModal open={true} locale={locale} />}
    </>
  )
}
export default RetirementReadinessResults
